import $ from 'cash-dom';

const ProfileFilter = () => {

	if (document.getElementsByClassName('profile-filter-mask').length <= 0) {
		var mask = document.createElement('div');
		mask.classList.add('profile-filter-mask');
		mask.style.display = 'none';
		mask.onclick = () => {
			this.style.display = 'none';
		};
		document.body.appendChild(mask);
	}

	// Return an array of the selected opion values
	// select is an HTML select element
	// see https://stackoverflow.com/questions/5866169/how-to-get-all-selected-values-of-a-multiple-select-box/5866331
	function getSelectValues(select) {
		var result = [];
		var options = select && select.options;
		var opt;

		for (var i=0, iLen=options.length; i<iLen; i++) {
			opt = options[i];

			if (opt.selected) {
				result.push(opt.value || opt.text);
			}
		}
		return result;
	}

	function updateSession(selects) {
		let sessionFilter = {
			branche: [],
			berufsgruppe: [],
			region: [],
			language: 'de'
		};
		selects.forEach((currentSelect) => {
			sessionFilter[currentSelect.getAttribute('id')] = window.choices[currentSelect.getAttribute('id')].getValue(true);
		});
		if (document.getElementsByTagName('html') && document.getElementsByTagName('html')[0].hasAttribute('lang')) {
			sessionFilter['language'] = document.getElementsByTagName('html')[0].getAttribute('lang');
		}
		sessionStorage.setItem('ems-filter', JSON.stringify(sessionFilter));
	}

	let tagIdUniqueCount = 0;

	Array.from(document.querySelectorAll('.profile-filter')).forEach(item => {

		tagIdUniqueCount++;

		let filters = {};
		let selects = Array.from(item.querySelectorAll('.js-choice'))

		window.choices = [];
		Array.from(document.querySelectorAll('.js-choice')).forEach(choiceSelect => {
			window.choices[choiceSelect.id] = new Choices(choiceSelect, {
				removeItemButton: true,
				renderSelectedChoices: 'always',
				duplicateItems: false,
				itemSelectText: '',
				resetScrollPosition: false,
				placeholderValue: choiceSelect.getAttribute('data-name'),
				callbackOnCreateTemplates: function (template) {
					let classNames = this.config.classNames;
					return {
						item: (data) => {
							return template(`
								<div
									class="${classNames.item} ${data.highlighted ? classNames.highlightedState : classNames.itemSelectable}"
									data-item
									data-id="${data.id}"
									data-value="${data.value}"
									data-deletable
									${data.active ?
										'aria-selected="true"' :
										''
										}
									${data.disabled ?
										'aria-disabled="true"' :
										''
										}
									>
									<span class="checkbox checkbox--active" data-button aria-label="Remove item: '${data.value}'"></span>
									${data.label}
								</div>
							`);
						},
						choice: (data) => {
							let choiceIsActive = false;
							Array.from(this.getValue()).forEach(valueObj => {
								if(valueObj.value == data.value) {
									choiceIsActive = true;
								}
							});
							return template(`
								<div
									class="${classNames.item} ${classNames.itemChoice} ${data.disabled ? classNames.itemDisabled : classNames.itemSelectable}"
									data-select-text="${this.config.itemSelectText}"
									data-choice
									data-id="${data.id}"
									data-value="${data.value}"
									${data.disabled ?
														'data-choice-disabled aria-disabled="true"' :
														'data-choice-selectable'
														}
									id="${data.elementId}"
									${data.groupId > 0 ?
														'role="treeitem"' :
														'role="option"'
														}
									>
									<span class="checkbox ${choiceIsActive ? 'checkbox--active' : ''}"></span><!--
									-->${data.label}
								</div>
							`);
						},
					};
				}
			});

			window.choices[choiceSelect.id].passedElement.addEventListener('choice', function(event) {
				let choiceIsActive = false;
				Array.from(window.choices[choiceSelect.id].getValue()).forEach(valueObj => {
					if(valueObj.value == event.detail.choice.value) {
						choiceIsActive = true;
					}
				});
				if (choiceIsActive) {
					setTimeout(() => {
						window.choices[choiceSelect.id].removeItemsByValue(event.detail.choice.value);

						// add "Alle" if needed
						if (window.choices[choiceSelect.id].getValue().length <= 0) {
							window.choices[choiceSelect.id].setValueByChoice('0');
						}
					}, 10);
				} else {
					if (event.detail.choice.value == '0') {
						window.choices[choiceSelect.id].removeActiveItems();
						window.choices[choiceSelect.id].setValueByChoice('0');
					}
				}
			}, false);

			window.choices[choiceSelect.id].passedElement.addEventListener('change', function(value) {
				let select = value.target;

				// remove "Alle" if no longer needed
				if (window.choices[select.id].getValue().length > 1) {
					window.choices[select.id].removeItemsByValue('0');
				}
				// add "Alle" if needed
				if (window.choices[select.id].getValue().length <= 0) {
					window.choices[select.id].setValueByChoice('0');
				}

				updateSession(selects);

			}, false);

			window.choices[choiceSelect.id].passedElement.addEventListener('showDropdown', function(event) {
				let otherFilters = Object.assign({}, filters);
				delete otherFilters[this.id];
				Array.from(document.getElementsByClassName('profile-filter-mask')).forEach(filterMask => {
					filterMask.style.display = 'block';
				});
			}, false);

			window.choices[choiceSelect.id].passedElement.addEventListener('hideDropdown', function(event) {
				Array.from(document.getElementsByClassName('profile-filter-mask')).forEach(filterMask => {
					filterMask.style.display = 'none';
				});
			}, false);

			filters[choiceSelect.id] = window.choices[choiceSelect.id].getValue().map(obj => {return obj.value;});

			// add "Alle" if needed
			if (window.choices[choiceSelect.id].getValue().length <= 0) {
				window.choices[choiceSelect.id].setValueByChoice('0');
			}
		});

		updateSession(selects);

	});

};

export default ProfileFilter;
